export const ITEM_UPLOAD_URL = '/items/new'
export const TERMS_URL = '/terms_and_conditions'
export const BUSINESS_TERMS_URL = '/pro-terms-of-use'
export const OUR_PLATFORM_URL = '/our-platform'
export const APP_LANDING_URL = '/app'
export const HELP_FAQ_ENTRIES_URL = '/help'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const COOKIE_POLICY_URL = '/cookie-policy'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
export const BUSINESS_ACCOUNTS_HOMEPAGE = '/pro'
export const BUSINESS_ACCOUNTS_GUIDE_URL = '/pro-guide'
export const MAIN_NAVIGATION_ABOUT_TAB_URL = '/about'
export const HELP_CENTER_URL = '/help'
export const HELP_SAFETY_URL = '/safety'
export const HOW_IT_WORKS_URL = '/how_it_works'
export const INFOBOARD_URL = '/infoboard'
export const ITEM_VERIFICATION_URL = '/item_verification'
export const ADVERTISING_URL = '/advertising'
export const JOBS_URL_NEW = 'https://careers.vinted.com/'
export const JOBS_URL = '/jobs'
export const ACCESSIBILITY_URL = '/accessibility'
